"use strict";
var transform = require('common/transform');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, urls, id, values, Flash, $timeout, permissions) {
  $scope.saveTempCollection = function() {
    if (typeof $scope.tempCollection == 'undefined') {
      return;
    }
    for (var i = 0; i < $scope.tempCollection.length; i++) {
      var index = $scope.collection.works.indexOf($scope.tempCollection[i]);
      if (index == -1 && $scope.addWorks) {
        $scope.collection.works.push($scope.tempCollection[i]);
      } else if (index > -1 && $scope.deleteWorks) {
        $scope.collection.works.splice(index, 1);
      }
    }
    $scope.update(id);
    $scope.finishEditing();
  };
  $scope.finishEditing = function() {
    $scope.editing = false;
    $scope.showFilter = false;
    $scope.hideOptions = false;
    $scope.selectedCollection = false;
    $scope.addWorks = false;
    $scope.deleteWorks = false;
    $scope.tempCollection = [];
    $scope.page = 1;
  };
  $scope.save = function() {
    if (id != null) {
      $scope.update(id);
    } else {
      $scope.create();
    }
  };
  $scope.setDisplayMode = function(mode) {
    $scope.displayMode = mode;
    $scope.refresh();
  };
  $scope.toggleAll = function() {
    var check = $('[name="toggleAll"]').prop('checked');
    for (var i = 0; i < $scope.works.length; i++) {
      var archivnr = $scope.works[i].archivnr;
      $('#' + archivnr).prop('checked', check);
      $scope.toggleCollection(archivnr);
    }
  };
  $scope.create = function() {
    if (!hlp.isSet($scope.collection.works)) {
      $scope.collection.works = [];
    }
    $http.post('/api/collection.json', angular.toJson($scope.collection)).then(function(response) {
      window.location = '/collection/edit/' + response.data._id.$oid;
    }, function(response) {
      var message = '<strong>Fehler beim speichern!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
  };
  $scope.update = function(id) {
    $http.post('/api/collection/' + id + '.json', angular.toJson($scope.collection)).then(function(response) {
      var message = '<strong>Erfolgreich gespeichert!</strong>.';
      Flash.create('success', message, 5000, {}, true);
      window.location = '/collection/' + id;
    }, function(response) {
      var message = '<strong>Fehler beim speichern!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
  };
  $scope.confirmDelete = function(flag) {
    $scope.showConfirmDelete = flag;
  };
  $scope.delete = function(id) {
    $scope.showConfirmDelete = false;
    $http.delete('/api/collection/' + id + '.json').then(function(response) {
      window.location = '/collection';
    }, function(response) {
      var message = '<strong>Fehler beim löschen!</strong>.';
      Flash.create('danger', message, 0, {}, true);
    });
  };
  var saveFilter = function(params) {
    localStorage.setItem($scope.filter, JSON.stringify(params));
  };
  $scope.getWorks = function() {
    $scope.loading = true;
    var params = {
      "archivnr": $scope.archivnr,
      "query": $scope.query,
      "page": $scope.page,
      "per_page": $scope.per_page
    };
    if ($scope.addWorks != true) {
      params["collectionId"] = id;
    }
    $http.get('/api/work.json', {params: params}).success(function(data, status, headers, config) {
      $scope.works = data.works;
      $scope.count = data.count;
      $timeout(function() {
        $scope.selectWorks();
        $scope.updateToggleAll();
        if ($scope.addWorks == true) {
          $scope.markWorks();
        }
      });
      params['displayMode'] = $scope.displayMode;
      saveFilter(params);
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.displayMultiple = function(values) {
    if (typeof values === 'undefined') {
      return '';
    }
    return values.join(', ');
  };
  $scope.thumbnailUrl = function(work) {
    return popup.thumbnailUrl(work, 256);
  };
  $scope.popup = function(archivnr, dianr) {
    popup.open(archivnr, dianr);
  };
  $scope.refresh = function() {
    $scope.getWorks();
  };
  $scope.refreshWithPage = function() {
    $scope.page = 1;
    $scope.getWorks();
  };
  $scope.$watch('page', function() {
    $scope.refresh();
  });
  $scope.$watch('per_page', function() {
    $scope.refresh();
  });
  $scope.$watch('doRefresh', function() {
    if ($scope.doRefresh) {
      $scope.refresh();
      $scope.doRefresh = false;
    }
  });
  $scope.setDisplayMode = function(mode) {
    $scope.displayMode = mode;
    $scope.refresh();
  };
  $scope.resetFilter = function() {
    localStorage.removeItem($scope.filter);
    initFilterDefaults();
    $scope.getWorks();
  };
  $scope.updateToggleAll = function() {
    var check = false;
    if ($('[name="archivnr"]:not(:checked)').length == 0) {
      check = true;
    }
    $('[name="toggleAll"]').prop('checked', check);
  };
  $scope.toggleCollection = function(archivnr) {
    if (typeof $scope.tempCollection == 'undefined') {
      $scope.tempCollection = [];
    }
    var checked = $('#' + archivnr).prop('checked');
    var index = $scope.tempCollection.indexOf(archivnr);
    if (checked == true) {
      if (index == -1) {
        $scope.tempCollection.push(archivnr);
      }
    } else {
      if (index > -1) {
        $scope.tempCollection.splice(index, 1);
      }
    }
  };
  $scope.markWorks = function() {
    for (var i = 0; i < $scope.works.length; i++) {
      var indexCollection = $scope.collection.works.indexOf($scope.works[i].archivnr);
      if (indexCollection > -1) {
        $('#' + $scope.works[i].archivnr).parents('tr').addClass('active');
      }
    }
  };
  $scope.selectWorks = function() {
    if (typeof $scope.tempCollection == 'undefined' || $scope.tempCollection.length == 0) {
      return;
    }
    for (var i = 0; i < $scope.works.length; i++) {
      var index = $scope.tempCollection.indexOf($scope.works[i].archivnr);
      if (index > -1) {
        $('#' + $scope.works[i].archivnr).prop('checked', true);
      }
    }
  };
  $scope.toggleAddWorks = function() {
    $scope.showFilter = true;
    $scope.hideOptions = true;
    $scope.selectedCollection = true;
    $scope.addWorks = true;
    $scope.editing = true;
    $scope.refresh();
  };
  $scope.toggleDeleteWorks = function() {
    $scope.showFilter = true;
    $scope.hideOptions = true;
    $scope.selectedCollection = true;
    $scope.deleteWorks = true;
    $scope.editing = true;
    $scope.refresh();
  };
  $scope.hasPermission = function(permission) {
    if (typeof $scope.permissions == 'undefined' || $scope.permissions == null) {
      return false;
    }
    var index = $scope.permissions.indexOf(permission);
    if (index > -1) {
      return true;
    }
    return false;
  };
  $scope.$watch('title', function() {
    if (hlp.isSet($scope.id) && hlp.isSet($scope.title)) {
      window.document.title = $scope.title + " - Sammlung";
    }
  }, true);
  $scope.privateFlagDisabled = function(flag) {
    if (flag.id == 'PRIVATE') {
      for (var i = 0; i < $scope.collection.flags.length; i++) {
        if ($scope.collection.flags[i] == 'PUBLIC') {
          return true;
        }
      }
    }
    return false;
  };
  var hasPublicFlag = function() {
    for (var i = 0; i < $scope.collection.flags.length; i++) {
      if ($scope.collection.flags[i] == 'PUBLIC') {
        return true;
      }
    }
    return false;
  };
  $scope.publicFlagDisabled = function(flag) {
    if (flag.id == 'PUBLIC') {
      if (hasPublicFlag()) {
        if (!$scope.hasPermission('remove_public_flag')) {
          return true;
        }
      } else {
        if (!$scope.hasPermission('add_public_flag')) {
          return true;
        }
      }
    }
    return false;
  };
  $scope.flagDisabled = function(flag) {
    return $scope.privateFlagDisabled(flag) || $scope.publicFlagDisabled(flag);
  };
  var initFilterDefaults = function() {
    $scope.per_page = 20;
    $scope.query = "";
    $scope.archivnr = "";
    $scope.page = 1;
    $scope.displayMode = 'table';
    $scope.query = "";
  };
  var initFilter = function() {
    var filter = localStorage.getItem($scope.filter);
    if (hlp.isSet(filter)) {
      var params = JSON.parse(filter);
      $scope.archivnr = params.archivnr;
      $scope.per_page = params.per_page;
      $scope.query = params.query;
      $scope.page = params.page;
      $scope.displayMode = params.displayMode;
    }
  };
  var init = function() {
    $scope.urls = urls;
    $scope.id = id;
    if (!hlp.isSet($scope.per_page)) {
      $scope.per_page = 10;
    }
    if (!hlp.isSet($scope.page)) {
      $scope.page = 1;
    }
    if (!hlp.isSet($scope.count)) {
      $scope.count = 0;
    }
    if (!hlp.isSet($scope.displayMode)) {
      $scope.displayMode = 'table';
    }
    $scope.permissions = permissions;
    $scope.tempCollection = [];
    $scope.filter = 'collection-works-list';
    if (values != "") {
      $scope.collection = JSON.parse(values);
      $scope.title = $scope.collection.name;
    } else {
      $scope.collection = {};
      $scope.title = "";
    }
    $scope.flags = [{
      "id": 'PRIVATE',
      "label": 'Privat'
    }, {
      "id": 'PUBLIC',
      "label": 'Öffentlich'
    }];
    initFilter();
  }();
};
module.exports = controller;
